export enum ENV_VAR {
  DEVELOPMENT = 'development',
  TEST = 'test',
  PRODUCTION = 'production',
}

export const API_MAP = new Map()
  .set(ENV_VAR.DEVELOPMENT, {
    fr: 'https://int.hoistfinance.fr',
    de: 'https://int.hoistfinance.de',
    es: 'https://int.hoistfinance.es',
    pl: 'https://int.hoistfinance.pl',
    it: 'https://int.hoistfinance.it',
    gr: 'https://int.hoistfinance.gr',
    nl: 'https://int.hoistfinance.nl',
    be: 'https://int.hoistfinance.be',
  });